import Dashboard from "MainPage/MainPage.jsx";
import LoginPage from "Login/screens/LoginPage.jsx";

const indexRoutes = [
    { path: "/login", component: LoginPage },
    { path: "/", component: Dashboard }
];

export default indexRoutes;